const ExpandLeftIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M7.828 13L12.485 17.657L11.071 19.071L4 12L11.071 4.92895L12.485 6.34295L7.828 11L17 11L17 13L7.828 13ZM21 4.99995L21 19L19 19L19 4.99995L21 4.99995Z" fill="black" />
        </svg>
    )
}

export default ExpandLeftIcon;